import LOADER_ANIMATION from './loader.json';

export const options = {
  animationData: LOADER_ANIMATION,
  loop: true,
};
